var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-mt-md"},_vm._l((_vm.errors),function(error){return _c('div',{key:error,staticClass:"text-negative"},[_vm._v("\n    — "+_vm._s(error)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }